import React, { useState, useEffect, useContext } from "react";
import creditcard from "../assets/images/Overview/credit-card.svg";
import Bank from "../assets/images/Overview/Bank_Account.svg";
import { Modal, Spinner } from "react-bootstrap";
import '../assets/css/Modal.css';
import { getApiService, postApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import ExpiryUpdateModal from "../components/ExpiryUpdateModal";
import { toast } from 'react-toastify';
import { LanguageContext } from "../contexts/LanguageContext";
import Cookies from 'js-cookie';

const MultipleAccounts = ({accountsModal, sendDataToOverview }) => {

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const Payload = GetPayLoad('PayLoad');

    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region
    };
   
    const [isLoading, setLoading] = useState(true);
    const [activeAccounts, setActiveAccounts] = useState([]);
    const [expiryModal, setExpiryModal] = useState(false);
    const [accountName, setAccountName] = useState();
    const [accountNo, setAccountNo] = useState();
    const [vaultId, setVaultId] = useState();
    const [accountType, setAccountType] = useState();
    const [expiryDate, setExpiryDate] = useState();
    const [apiCall, setApiCall] = useState(true);
    const [primaryAccount, setPrimaryAccount] = useState([]);
    const [errorFlag, setErrorFlag] = useState(false);
    const [isPrimaryLoading, setPrimaryLoading] = useState(false);

    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);

    useEffect(() => {
        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }

        if(accountsModal && apiCall) {
            fetchAPI();
        }
    
    }, [pageContent]);

    const handleExpiryModal = (accountName, accountNo, vaultId, accountType, expiryDate) => {        
        setExpiryModal(true);
        setAccountName(accountName);
        setAccountNo(accountNo);
        setVaultId(vaultId);
        setAccountType(accountType);
        setExpiryDate(expiryDate)
    }
    
    function handleDataFromModal(message, response) {
        if(message !== ''){
            if(response === 'success'){
                toast.success(message);
            }else{
                toast.error(message);
            }
            fetchAPI();
        }
    }
    
    function fetchAPI(){

        const targetGetActiveAccountsUrl = process.env.REACT_APP_API_GET_ACTIVE_ACCOUNTS_ENDPOINT;
        getApiService(baseUrl, targetGetActiveAccountsUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    setErrorFlag(false);
                    const result = response.data.data;
                    setActiveAccounts(result);
                    setApiCall(false);

                    if(result.length > 0){
                        const targetGetPrimaryAccountUrl = process.env.REACT_APP_API_GET_PRIMARY_ACCOUNT_ENDPOINT;
                        getApiService(baseUrl, targetGetPrimaryAccountUrl, { cim: Payload?.cim }, headers)
                        .then((response) => {
                            setLoading(false);
                            if (response?.data?.statusCode !== 200) {
                                setErrorFlag(true);
                            }else{
                                setErrorFlag(false);
                                const result = response.data.data;
                                setPrimaryAccount(result);
                                setApiCall(false);
                            }
                        })
                        .catch(error => {
                            setLoading(false);
                            setErrorFlag(true);
                        });
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                setErrorFlag(true);
            });
    }
   
    const handlePrimaryAccount = (account_type, vaultId) => {
        setPrimaryLoading(true);

        const targetPrimaryAccountUrl = process.env.REACT_APP_API_SAVE_PRIMARY_ACCOUNT_ENDPOINT;
        const payload = new FormData();
        payload.append("cim", Payload?.cim);
        payload.append("accountType", account_type);
        payload.append("vaultId", vaultId);
        postApiService(baseUrl, targetPrimaryAccountUrl, payload, headers)
            .then((response) => {
                setPrimaryLoading(false);
                if (response?.data?.statusCode !== 200) {
                    sendDataToOverview(genericContent?.service_post_error, 'error');
                }else{
                    sendDataToOverview(overViewContent?.overview_multiple_accounts_primary_account_success_msg, 'success');
                    fetchAPI();
                }
            })
            .catch(error => {
                setPrimaryLoading(false);
                sendDataToOverview(genericContent?.service_post_error, 'error');
            });
    }

    return (<>
        <Modal size="x1" show={expiryModal} onHide={() => { setExpiryModal() }}>
            <ExpiryUpdateModal accountName={accountName} accountNo={accountNo} vaultId={vaultId} accountType={accountType} expiryDate={expiryDate} setExpiryModal={setExpiryModal} sendDataToParent={handleDataFromModal} />
        </Modal>
        <Modal.Header className={`multipleaccounts pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
            <Modal.Title>
                <h4 tabIndex={0}>{overViewContent?.overview_multiple_accounts_title}</h4>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div tabIndex={0} className="grey-bg rounded px-4 py-4 mb-4 custom-rounded">
                <p>
                    <b>{overViewContent?.overview_multiple_accounts_note}</b>
                    {overViewContent?.overview_multiple_accounts_note_content}
                </p>
            </div>
            {errorFlag && (
                <div tabIndex={0} className="api-error-msg">
                    {genericContent?.accounts_info_service_error}
                </div>
            )}
            {isLoading && (
                <div tabIndex={0} style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                    <Spinner animation="border" role="status" ></Spinner>
                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                </div>
            )}
            {!isLoading && !errorFlag && activeAccounts.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    {
                        activeAccounts && activeAccounts?.map((item, index) => {
                            let  hideCreditCard = (Cookies.get('owningCarrier') === 'Q5' && item?.cardType === 'CCD' && Cookies.get('binder_payment_flag') === 'false') ? true : false;
                        
                        return (
                            !hideCreditCard && (
                                <div className={(primaryAccount?.MainAccountType === item?.mainAccountType && primaryAccount?.vault_id === item?.vaultId && primaryAccount?.primaryActive === 'Y') ? 'primaryActive' : 'primaryDefault'} key={index} style={{ padding: '15px', display: 'flex', justifyContent: 'space-between', borderRadius: '15px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <div tabIndex={0} className="paymode-bg rounded-circle text-center">
                                            <img width={item?.mainAccountType !== 'EFT' ? '24px' : '27px'} height={item?.mainAccountType !== 'EFT' ? '24px' : '27px'} src={item?.mainAccountType === 'EFT' ? Bank : creditcard} alt="account" />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                                            <div tabIndex={0}>
                                                <h4 className="more-h4" >{item?.mainAccountType === 'EFT' ? overViewContent?.overview_multiple_accounts_eft_account : overViewContent?.overview_multiple_accounts_card_number }</h4>
                                                <label className="more-label">{item?.mainAccountType === 'EFT' ? overViewContent?.overview_multiple_accounts_eft_account_number : overViewContent?.overview_multiple_accounts_card_number_star} {item?.accountNumLastFour}</label>
                                            </div>
                                            <div tabIndex={0}>
                                                <h4 className="more-h4">{item?.mainAccountType === 'EFT' ? overViewContent?.overview_multiple_accounts_account_type : overViewContent?.overview_multiple_accounts_card_exp_date }</h4>
                                                <label className="more-label">{item?.mainAccountType === 'EFT' ? (genericContent?.[
                                                "account_type_" +
                                                item?.detailedAccountType.toLowerCase()
                                              ] || item?.detailedAccountType) : item?.ExpiryDate}
                                                    {(item?.accountType === 'CCD') && (
                                                        <i tabIndex={0} aria-label="expiration date clickable edit option" className="fe fe-edit-2 ms-2" style={{cursor: 'pointer'}} onClick={(e) => handleExpiryModal(item?.accountName, item?.accountNumLastFour, item?.vaultId, item?.accountType, item?.ExpiryDate, e)}
                                                            onKeyDown={(e) => handleExpiryModal(item?.accountName, item?.accountNumLastFour, item?.vaultId, item?.accountType, item?.ExpiryDate, e)}
                                                        ></i>
                                                    )}
                                                </label>{hideCreditCard}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                                        {isPrimaryLoading && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                <Spinner animation="border" role="status" ></Spinner>
                                            </div>
                                        )}
                                        {!isPrimaryLoading && (primaryAccount?.MainAccountType === item?.mainAccountType && primaryAccount?.vault_id === item?.vaultId && primaryAccount?.primaryActive === 'Y') ? ( 
                                            // st48236 - change class name for primary button - style guide
                                            <button className={primaryAccount?.primaryActive === 'Y' ? (Payload?.owning_carrier === 'Q5' ? 'btn btn-outline-secondary btn-md rounded me-3' : 'btn btn-warning btn-sm rounded') : 'more-select'}>{overViewContent?.overview_multiple_accounts_primary_account}</button> )
                                        :
                                        (!isPrimaryLoading &&
                                            <button 
                                            className='btn btn-primary btn-md rounded-pill btn-slctprimary'
                                            onClick={(e) => handlePrimaryAccount(item?.mainAccountType, item?.vaultId)}
                                            >
                                                {overViewContent?.overview_multiple_accounts_select_primary}
                                            </button>   
                                        )
                                        }
                                        {isLoading && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit', float: 'right', paddingTop: '25px' }}>
                                            <Spinner animation="border" role="status" ></Spinner>
                                            <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                        </div>
                                        )}
                                    </div>
                                </div>
                        )
                        )
                    } )
                    }
                </div>
            )
            :
            (
                (!isLoading && !errorFlag) && (
                    <div className='labels'><label className='label-heading'>{overViewContent?.overview_multiple_accounts_no_data_text}</label></div>
                )
            )
            }
        </Modal.Body>
    </>)
}

export default MultipleAccounts;